import { Participant } from '@seen/core/models/patients/participant'
import { getSearchKey, normalizeQuery } from '@seen/core/search'
import { useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'
import { cacheKeys } from '#src/hooks/cacheKeys.ts'
import { useMedplum } from '#src/hooks/useMedplum.ts'
import { useSearch } from '#src/hooks/useSearch.ts'

export function useParticipantsActive(): Participant[] {
  // We try to use the cached participants first, but if they're not available, we fetch a smaller subset from the server
  const medplum = useMedplum()
  const queryClient = useQueryClient()
  const searchKey = getSearchKey(
    medplum,
    Participant.RESOURCE_TYPE,
    normalizeQuery(Participant.baseSearchQuery())
  )
  const maybeCachedParticipants = queryClient.getQueryData<Participant[]>(
    cacheKeys.searchResourcePages(Participant.RESOURCE_TYPE, searchKey)
  )
  const { data: participantSubset } = useSearch(
    Participant,
    Participant.enrolledSearchQuery(),
    { query: { enabled: !maybeCachedParticipants } }
  )
  const participants =
    maybeCachedParticipants ?? participantSubset ?? EMPTY_PARTICIPANTS

  const activeParticipants = useMemo(
    () => participants.filter((participant) => participant.isActive),
    [participants]
  )
  return activeParticipants
}

const EMPTY_PARTICIPANTS: Participant[] = []
